/**
 * V325.12: Session-scoped photo URL cache (UserPhoto dedup)
 * Extracted so self-profile recovery can invalidate without importing UserPhoto.tsx.
 */

// V325.12: Global Photo Dedup - Cache by USER + VARIANT (avatar vs hero)
export const PHOTO_CACHE_PREFIX = 'bn:photo:v1:';
const PHOTO_TTL_MS = 24 * 60 * 60 * 1000;

const memPhotoUrl = new Map<string, { url: string; ts: number }>();

export function makePhotoKey(userId: string, variant: 'avatar' | 'hero', w: number, h: number): string {
  return `${PHOTO_CACHE_PREFIX}${userId}:${variant}:${w}x${h}:webp:qauto:fill:faces`;
}

export function getCachedUrl(key: string): string | null {
  const mem = memPhotoUrl.get(key);
  if (mem) {
    if (Date.now() - mem.ts <= PHOTO_TTL_MS && mem.url) return mem.url;
    memPhotoUrl.delete(key);
  }

  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data?.url) return null;
    if (Date.now() - (data.ts || 0) > PHOTO_TTL_MS) {
      sessionStorage.removeItem(key);
      return null;
    }
    memPhotoUrl.set(key, { url: data.url, ts: data.ts || Date.now() });
    return data.url;
  } catch {
    return null;
  }
}

export function setCachedUrl(key: string, url: string): void {
  if (!url) return;
  const payload = { url, ts: Date.now() };
  memPhotoUrl.set(key, payload);
  try {
    sessionStorage.setItem(key, JSON.stringify(payload));
  } catch {
    /* ignore */
  }
}

/** Clear all session avatar/hero cache entries for a user (after self-recovery or upload). */
export function invalidateUserPhotoCache(userId: string): void {
  if (!userId) return;
  for (const k of Array.from(memPhotoUrl.keys())) {
    if (k.startsWith(PHOTO_CACHE_PREFIX + userId + ':')) memPhotoUrl.delete(k);
  }
  try {
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
      const k = sessionStorage.key(i);
      if (k && k.startsWith(PHOTO_CACHE_PREFIX + userId + ':')) {
        sessionStorage.removeItem(k);
      }
    }
  } catch {
    /* ignore */
  }
}
